import React from "react";
import { Link } from "react-router-dom";

import "./Home.css";
import { Seo } from '../layouts/Seo';
import {LogoScroll} from '../comp/LogoScroll';

function redirectHash(hash) {
  console.log(hash)
  if (hash === "press") {
    window.location.href = '/press'
  }
  else if (hash === "capabilities") {
    window.location.href = '/capabilities'
  }
  else if (hash === "contact") {
    window.location.href = '/contact'
  }
}

const FeatureBoxes = () => {
  const features = [
    {
      title: 'Advanced Data Science',
      description: 'Extracting breakthrough insights from the most complex datasets using cutting-edge machine learning and statistical methods that others can\'t master. ',
      cta: 'Learn More',
      url: '/capabilities/data_analysis'
    },
    {
      title: 'Bespoke Development',
      description: 'Custom data engineering, pipelines, AI and machine learning solutions built specifically for your business requirements - no generic templates or one-size-fits-all approaches.',
      cta: 'Learn More',
      url: '/solutions'
    },
    {
      title: 'Expert-Level Training',
      description: 'Specialized community, corporate and academic programs that elevate team and leadership capabilities to world-class levels, taught by true masters of the craft.',
      cta: 'Explore Now',
      url: '/events/workshop'
    },
  ];

  return (

<div class="row p-0 gap-4 bg-transparent">
      {features.map((feature, index) => (
        <div class="card col-md-3 px-0" >
          <div class="card-header">
            {feature.title}
          </div>
          <div class="card-body">
            <p class="card-text">{feature.description}</p>
          </div>
          <div class="card-footer">
            <a href={feature.url} class="btn btn-sm btn-primary">{feature.cta}</a>
          </div>
        </div>
      ))}

    </div>
  );
};

const Home = () => {

  const path = window.location.href;
  const hash =
  path.indexOf("#") !== -1 ? path.slice(path.indexOf("#") + 1) : "";
  if (hash) {
    redirectHash(hash);
  }

  return (
    <>

    <Seo
        title="Saigon A.I. - Elite AI Expertise for the World's Most Challenging Problems"
        description="When conventional solutions fail and the stakes are highest, discerning organizations turn to our team of battle-tested AI scientists and engineers."
        type="webapp"
      />
{/*}
<div class="container col-xxl-12 px-4" >
  <div class="row flex-lg-row-reverse align-items-center g-4">
    <div class="col-12">
      <a href="/events/workshop"><img src="/img/workshop_front_page.png" alt="Saigon A.I. Cutting through the Noise Workshop Series" class="d-block mx-lg-auto img-fluid roundy20" width="60%" loading="lazy" /></a>
      <p align="center"><a href="/events/workshop"><strong>Click here</strong></a> for more Information</p>
    </div>
  </div>
</div> */}

  <div class="row flex-lg-row-reverse align-items-center g-4 py-3">
    <div class="col-md-6">
      <p class="fs-1">Elite AI Expertise for the World's Most Challenging Problems</p>

      <p class="fs-5">When conventional solutions fail and the stakes are highest, discerning organizations turn to our team of battle-tested AI scientists and engineers.  
        <Link to="/solutions/classic_vs_genai">We don't just throw all the hype-backed solutions at you</Link>. We help you navigate the best tech for your use cases.</p>

      <Link to="/capabilities/data_analysis" class="btn btn-xs btn-outline-light btn-hmar-2" onclick="load_page(this)" data-content="content/data_analysis">Advanced Data Science</Link>
      <Link to="/solutions" class="btn btn-xs btn-outline-light btn-hmar-2" onclick="load_page(this)" data-content="content/ml_model">Bespoke AI Development</Link>
      <Link to="/events/workshop" class="btn btn-xs btn-outline-light btn-hmar-2" onclick="load_page(this)" data-content="content/ml_model">Expert-Level Training</Link>
      
    </div>
    <div class="col-md-6">
          <img class="rounded img-fluid mh-100 object-fit-cover" alt="Saigon AI Team 2024" src="/img/team_retreat.jpg"></img>

    </div>
  </div>

  <LogoScroll />

  <div class="row flex-lg-row-reverse align-items-center g-4 py-1">
    <div class="col-12">
      <p class="fs-3 pt-4">Never been done before? We love projects like that.</p>
    </div>
  </div>
  <div class="row align-items-center g-4 py-3">
    <div class="col-md-7 p-2">
      <p>We are not like other tech companies.  We are deeply relationship driven, and thrive when we are part of the innovation process.  We are focused on quality over volume.  We are selective about who we work with for a lot of reasons.  Ask us about it! We will be glad to share about how our company culture makes a big difference.</p>
    </div>
    <div class="col-md-5">
      <p class="lh-sm py-0"><img alt="check" class="px-2" src="/img/checkmark.png"></img>25+Years Combined Experience</p>
      <p class="lh-lg"><img alt="check" class="px-2" src="/img/checkmark.png"></img>100% Scientifically Proven Methods</p>
      <p class="lh-lg"><img alt="check" class="px-2" src="/img/checkmark.png"></img>Innovation and Design Thinking</p>

      
      
    </div>

  </div>

<FeatureBoxes/>



    </>
    )
  };
  
  export default Home;